var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.canBeShown),expression:"canBeShown"}]},[_c('contest-menu',{attrs:{"visible":_vm.isVisible},on:{"hide":_vm.closeMenu}}),_vm._v(" "),_c('menu-button',{attrs:{"type":_vm.menuButtonType},on:{"click":_vm.toggleMenu}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51faaf5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/ContestMenu/ContestMenuContainer.vue
// module id = null
// module chunks = 